import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'social-channel-card',
	templateUrl: './social-channel-card.component.html',
	styleUrls: ['./social-channel-card.component.scss']
})

export class SocialChannelCardComponent implements OnInit {

	@Input() banner: string;
	@Input() logo: string;
	@Input() url: string;
	@Input() title: string;
	@Input() authentication?: boolean;

	constructor() { }

	ngOnInit() { }
}
